import { Component, OnDestroy, Output, EventEmitter } from '@angular/core';

import { TargetingResultModel } from '../../../../../Discover/Targeting/models/targeting-result.model';
import { TargetingSearchService } from '../../../../../Discover/Targeting/services/targeting-search.service';
import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { TargetingListService } from '../../../../../Discover/Targeting/services/targeting-list.service';
import { ResultCardDirective } from '../../../../TargetingShared/components/ResultCard/result-card.directive';
import { ListPickerService } from '../../../services/list-picker.service';
import { TargetingRhpContextsService } from '../../../../TargetingShared/services/targeting-rhp-contexts.service';
import { EntityTypeDefaultImageEnum } from '../../../../Misc/enums/entity-type-default-image.enum';
import { ManageListDialogComponent } from '../../../../../Discover/Targeting/components/TargetingResults/ManageListDialog/manage-list-dialog.component';
import { ButtonTypesEnum } from '../../../../Forms/enums/button-types.enum';
import { DistributionPickerService } from '../../../services/distribution-picker.service';


@Component({
    selector: 'agpr-staff-card',
    templateUrl: './staff-card.component.html',
    styleUrls: ['./staff-card.component.scss'],
    standalone: false
})
export class StaffCardComponent extends ResultCardDirective implements OnDestroy {

    @Output() selectionChanged: EventEmitter<TargetingResultModel[]> = new EventEmitter();
    @Output() showRhpTakeOver?: EventEmitter<any> = new EventEmitter<any>();


    readonly imageDefault = EntityTypeDefaultImageEnum;
    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        public targetingSearchService: TargetingSearchService,
        public targetingListService: TargetingListService,
        public listPickerService: ListPickerService,
        public localizationService: LocalizationService,
        public coreDialogService: CoreDialogService,
        public targetingRhpContextsService: TargetingRhpContextsService,
        public distributionPickerService: DistributionPickerService,
    ) {
        super(targetingSearchService,
            targetingListService,
            listPickerService,
            localizationService,
            coreDialogService,
            targetingRhpContextsService,
            distributionPickerService);
    }

    onCardClicked(entity: TargetingResultModel) {
        this.showRhpTakeOver.emit({entityType: entity.entityType, contactId: entity.id, outletId: entity.selectedEmployment?.outlet?.id});
    }

    openManageListDialog(entity: TargetingResultModel) {
        this.coreDialogService.open(ManageListDialogComponent, {
            inputs: {
                setEntity: entity
            },
            outputs: {}
        });
    }
}
